import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './article-combo.component.scss';
var ArticleCombo = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleCombo, _super);
    function ArticleCombo(element) {
        return _super.call(this, element) || this;
    }
    ArticleCombo.prototype.init = function () {
        // override article subtitle date
        if (this.element.querySelector('.article-combo-item__subtitle--date')) {
            var subtitleDates = Array.from(this.element.querySelectorAll('.article-combo-item__subtitle--date'));
            subtitleDates.forEach(function (item) {
                var subtitleDateInnerHTML = item.innerHTML;
                var subtitleDateInnerHTMLReplace = subtitleDateInnerHTML.replace('January', 'Jan');
                subtitleDateInnerHTMLReplace = subtitleDateInnerHTMLReplace.replace('February', 'Feb');
                subtitleDateInnerHTMLReplace = subtitleDateInnerHTMLReplace.replace('March', 'Mar');
                subtitleDateInnerHTMLReplace = subtitleDateInnerHTMLReplace.replace('April', 'Apr');
                subtitleDateInnerHTMLReplace = subtitleDateInnerHTMLReplace.replace('May', 'May');
                subtitleDateInnerHTMLReplace = subtitleDateInnerHTMLReplace.replace('June', 'Jun');
                subtitleDateInnerHTMLReplace = subtitleDateInnerHTMLReplace.replace('July', 'Jul');
                subtitleDateInnerHTMLReplace = subtitleDateInnerHTMLReplace.replace('August', 'Aug');
                subtitleDateInnerHTMLReplace = subtitleDateInnerHTMLReplace.replace('September', 'Sep');
                subtitleDateInnerHTMLReplace = subtitleDateInnerHTMLReplace.replace('October', 'Oct');
                subtitleDateInnerHTMLReplace = subtitleDateInnerHTMLReplace.replace('November', 'Nov');
                subtitleDateInnerHTMLReplace = subtitleDateInnerHTMLReplace.replace('December', 'Dec');
                item.innerHTML = subtitleDateInnerHTMLReplace;
            });
        }
    };
    ArticleCombo.prototype.bindEvents = function () {
    };
    return ArticleCombo;
}(Base));
export { ArticleCombo };



//////////////////
// WEBPACK FOOTER
// ./components/article-combo/article-combo.component.ts
// module id = 93
// module chunks = 0